.choiceCard {
  width: 100%;
  padding: var(--dixa-size-spacer-200) var(--dixa-size-spacer-300);
  border: var(--dixa-size-border-100) solid var(--dixa-color-neutral-200);
  border-radius: var(--dixa-size-border-radius-100);
  background-color: transparent;
  text-align: left;
  cursor: pointer;

  &:hover {
    background-color: var(--dixa-color-neutral-100);
  }

  &:focus-visible {
    outline: var(--dixa-size-border-200) solid var(--dixa-color-purple-300);
    outline-offset: var(--dixa-size-border-100);
  }
}
